import React from "react";
import Loader from "../components/Loader";

import GenomeBrowser from "../components/GenomeBrowser";

import {
  Button,
  ButtonGroup,
  Checkbox,
  Chip,
  Divider,
  FormControlLabel,
  IconButton,
  InputBase,
  TextField,
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
} from "@mui/material";

import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import DataTable from "../components/DataTable";

const karyo = {
  "NW_024423343.1": 107602085,
  "NW_024424452.1": 105444388,
  "NW_024425563.1": 103141129,
  "NW_024426552.1": 94239067,
  "NW_024426663.1": 89363090,
  "NW_024426774.1": 85471795,
  "NW_024426885.1": 84194765,
  "NW_024426996.1": 82355413,
  "NW_024427107.1": 80875305,
  "NW_024423344.1": 79717664,
  "NW_024423453.1": 72485884,
  "NW_024423564.1": 72237886,
  "NW_024423675.1": 70735958,
  "NW_024423786.1": 70491230,
  "NW_024423897.1": 63533026,
  "NW_024424008.1": 63497499,
  "NW_024424119.1": 60610930,
  "NW_024424230.1": 58454814,
  "NW_024424341.1": 57961497,
  "NW_024424453.1": 57369422,
  "NW_024424564.1": 57186674,
  "NW_024424675.1": 48157264,
  "NW_024424786.1": 47470262,
  "NW_024424897.1": 46365385,
  "NW_024425008.1": 45593848,
  "NW_024425119.1": 45154613,
  "NW_024425230.1": 39688831,
  "NW_024425341.1": 39403761,
  "NW_024425452.1": 35753608,
  "NW_024425564.1": 35087990,
  "NW_024425675.1": 32704316,
  "NW_024425786.1": 30957443,
  "NW_024425897.1": 30274211,
  "NW_024426008.1": 29374380,
  "NW_024426119.1": 27738559,
  "NW_024426230.1": 24883053,
};
const chrset = Object.keys(karyo).map((c) => ({ label: c, size: karyo[c] }));

class VariantsPage extends React.Component {
  constructor(props) {
    super(props);
    this.that = props.that;
    this.loader = new Loader(this);
    let chr = Object.keys(karyo)[0];
    this.state = {
      items: [],
      header: [],
      chr: chr,
      start: parseInt(karyo[chr] / 10),
      end: parseInt((karyo[chr] / 10) * 2),
      chrSize: karyo[chr],
    };

    this.setDimensions = this.setDimensions.bind(this);
  }

  zoom(k) {
    let range = this.state.end - this.state.start;
    let offset = Math.round((range * (1 - k)) / 2);

    this.setPosition({
      start: this.state.start + offset,
      end: this.state.end - offset,
    });
  }

  move(k) {
    let range = this.state.end - this.state.start,
      start,
      end;
    if (k > 0) {
      end = Math.min(
        Math.round(this.state.end + range * k),
        this.state.chrSize
      );
      start = end - range;
    } else {
      start = Math.max(Math.round(this.state.start + range * k), 0);
      end = start + range;
    }
    this.setPosition({ start: start, end: end });
  }

  setPosition(info) {
    info.start = parseInt(info.start) || this.state.start;
    info.end = parseInt(info.end) || this.state.end;

    if (info.start > info.end)
      info.end = [info.start, (info.start = info.end)][0]; // Flip
    const width = Math.round((info.end - info.start) / 2) * 2;
    if (width < 100) {
      info.start -= (100 - width) / 2;
      info.end += (100 - width) / 2;
    }
    if (info.start < 0) info.start = 0;
    if (info.end > this.state.chrSize) info.end = this.state.chrSize;

    this.setState(info, () => {
      this.state.browser.setPosition(this.state);
      this.onPositionUpdate([info.start, info.end]);
    });
  }

  setDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  makeTable(info) {
    let sample = {};
    info["samples"].map((s) => (sample[s.id] = s));
    let variant = {};
    info["snp"].map((s) => (variant[s.id] = s));

    let items = info["call"].map((c) => {
      let o = { ...sample[c.sample_id], ...variant[c.variant_id], ...c };
      console.log("CALL", c);
      console.log("sample", sample[c.sample_id]);
      console.log("variant", variant[c.variant_id]);
      console.log("join", o);
      return o;
    });

    let head = [
      {
        id: 1000,
        label: "alt",
        name: "Alt",
        type: "string",
        preview: 1,
      },
      {
        id: 1001,
        label: "ref",
        name: "Ref",
        type: "string",
        preview: 1,
      },
      {
        id: 1001,
        label: "freq",
        name: "Freq",
        type: "float",
        preview: 1,
      },
      {
        id: 1000,
        label: "gt",
        name: "Genotype",
        type: "string",
        preview: 1,
      },
    ];
    let sel = [
      "No",
      "Collection_region",
      "Collection_site",
      "Collection_time",
      "Collector",
    ];
    info["header"].map((e) => {
      if (sel.indexOf(e.label) != -1) {
        e.preview = 1;
        head.push(e);
      }
    });

    // info["header"] = head;
    // console.log("ITEMS", items, info["header"]);
    this.setState({ items: items, header: head });
  }

  loadSNP() {
    const region = `${this.state.chr}:${this.state.start}-${this.state.end}`;
    this.loader.get("snp/" + region, {}, (u, data) => {
      this.makeTable(data["data/snp/moderate"]);
      // data["table"] = ;
      this.setState(data, () => {
        this.state.browser.loadData(this.state);
      });
      //this.state.browser.loadData(this.state);
    });
  }

  onPositionUpdate(p) {
    this.setState({ start: p[0], end: p[1] }, () => {
      this.loadSNP();
      //this.loadFeatures();
      //for (let impact in this.state.filters.snp) this.loadSNP(impact);
      //this.loadSV();
    });

    // const region = `${this.state.chr}:${p[0]}-${p[1]}`;
    // window.history.pushState({}, region, `/region/${region}`);
  }

  componentDidMount() {
    this.setDimensions();
    window.addEventListener("resize", this.setDimensions);
    this.setState({ browser: GenomeBrowser("#region", this) });
  }

  renderPanel() {
    return (
      <div className={"control-panel shadow"}>
        <Autocomplete
          className="chr"
          options={chrset}
          value={chrset[0]}
          getOptionLabel={(e) => e.label}
          disableClearable
          size="small"
          onChange={(e, newValue) => {
            let chr = newValue.label;
            this.setState(
              {
                chr: chr,
                start: parseInt(karyo[chr] / 10),
                end: parseInt((karyo[chr] / 10) * 2),
              },
              () => {
                this.setState({ browser: GenomeBrowser("#region", this) });
              }
            );
          }}
          renderInput={(params) => <TextField {...params} label="Chromosome" />}
        />

        <IconButton onClick={() => this.move(-1.0)}>
          <KeyboardDoubleArrowLeftIcon />
        </IconButton>
        <IconButton onClick={() => this.move(-0.3)}>
          <ChevronLeftIcon />
        </IconButton>

        <TextField
          onChange={(e) => this.setState({ start: e.target.value })}
          onBlur={(e) => this.setPosition({ start: e.target.value })}
          value={this.state.start}
          label="Start"
          variant="outlined"
          size="small"
        />
        <TextField
          onChange={(e) => this.setState({ end: e.target.value })}
          onBlur={(e) => this.setPosition({ end: e.target.value })}
          value={this.state.end}
          label="End"
          variant="outlined"
          size="small"
        />

        <IconButton onClick={() => this.move(1.0)}>
          <ChevronRightIcon />
        </IconButton>
        <IconButton onClick={() => this.move(0.3)}>
          <KeyboardDoubleArrowRightIcon />
        </IconButton>

        <IconButton onClick={() => this.zoom(2.0)}>
          <ZoomOutIcon />
        </IconButton>
        <IconButton onClick={() => this.zoom(0.5)}>
          <ZoomInIcon />
        </IconButton>
      </div>
    );
  }

  render() {
    return (
      <div className={"page"}>
        <div className={"header"}>
          <h2>Variants</h2>
        </div>

        {this.renderPanel()}

        <div className={"custom-table chart-wrapper"}>
          <div className={"custom-body"}>
            <div className={"region-chart"} id={"region"} />
            {this.state.items.length ? (
              <DataTable that={this} root={this.that} />
            ) : (
              <Alert severity="error">No SNV found for this region!</Alert>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default VariantsPage;
